"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inDOM = _interopRequireDefault(require("../util/inDOM"));
var _on = _interopRequireDefault(require("./on"));
var _off = _interopRequireDefault(require("./off"));
var listen = function listen() {};
if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}
var _default = listen;
exports.default = _default;
module.exports = exports["default"];